/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignTokenRouteImport } from './routes/sign/$token'
import { Route as ReviewTokenRouteImport } from './routes/review/$token'

const SignTokenRoute = SignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewTokenRoute = ReviewTokenRouteImport.update({
  id: '/review/$token',
  path: '/review/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
}
export interface FileRoutesByTo {
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/review/$token': typeof ReviewTokenRoute
  '/sign/$token': typeof SignTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/review/$token' | '/sign/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/review/$token' | '/sign/$token'
  id: '__root__' | '/review/$token' | '/sign/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ReviewTokenRoute: typeof ReviewTokenRoute
  SignTokenRoute: typeof SignTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign/$token': {
      id: '/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof SignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$token': {
      id: '/review/$token'
      path: '/review/$token'
      fullPath: '/review/$token'
      preLoaderRoute: typeof ReviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  ReviewTokenRoute: ReviewTokenRoute,
  SignTokenRoute: SignTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
